import React, { useEffect, useState } from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/swiper-bundle.css'
import { Chip, SwiperContainer } from './swiperStyles'
// import { CHIPS } from './content'
import { handleSwiperTranslate } from './helpers/swiperTranslate'
import { handleResetChipsScale } from './helpers/resetChipsScale'
// import { handleSwiperProgress } from './helpers/swiperProgress'
import useSound from 'use-sound'
import ChipSelect from '../../../lib/assets/audio/chipsSelection.mp3'
import {
  formatMin,
  formatThousand,
  formatThousandWithDecimals,
} from '../helpers/helperChip'
// import Swipe from '../../../lib/assets/audio/chipsSelection.mp3'

export default function ChipSwiper({
  gameInfo,
  handleChip,
  gameState,
  audio,
}: any) {
  const [currentChip, setCurrentChip] = useState<number>(0)
  const [anim, setAnim] = useState<boolean>(false)

  const [chipSelectSFX] = useSound(ChipSelect, {
    volume: audio?.volume ? parseFloat(audio.volume) : 0,
  })

  const handleCurrentChip = (c: string, id: number) => {
    audio.sound && chipSelectSFX()
    handleChip(c)
    setAnim(true)
    setTimeout(() => {
      setAnim(false)
    }, 167)
  }
  const handleSwipe = (e: any) => {
    handleSwiperTranslate(e)
  }
  const [min, setMin] = useState<number>(0.1)
  const [max, setMax] = useState<number>(100)

  useEffect(() => {
    const minBet = gameInfo.minBet
    const maxBet = gameInfo.maxBet
    setMin(minBet)
    setMax(maxBet)
  }, [gameInfo])

  const formatNumber = (n: number) => {
    let newNum = Math.ceil(n).toString()
    if (+newNum > 999) {
      if (formatThousandWithDecimals(max) === formatThousand(+n)) {
        newNum = formatThousandWithDecimals(n)
      } else newNum = formatThousand(n)
    } else {
      if (+newNum > 100) {
        newNum = (Math.ceil(+newNum / 100) * 100).toString()
      } else newNum = (Math.ceil(+newNum / 10) * 10).toString()
    }
    return newNum
  }

  //  ['100, '0.1', '0.2', '0.5', '1', '5', '10', '25', '50']
  const CHIPS =
    min <= 1
      ? [
          formatThousandWithDecimals(max),
          min.toString(),
          '2',
          '5',
          '10',
          '15',
          '20',
          '25',
          '50',
        ]
      : [
          formatThousandWithDecimals(max),
          formatMin(min),
          formatNumber(min + (max - min) / 100),
          formatNumber(min + (2 * (max - min)) / 100),
          formatNumber(min + (3 * (max - min)) / 60),
          formatNumber(min + (4 * (max - min)) / 40),
          formatNumber(min + (5 * (max - min)) / 25),
          formatNumber(min + (6 * (max - min)) / 15),
          formatNumber(min + (7 * (max - min)) / 10),
        ]

  return (
    <SwiperContainer gameState={gameState}>
      <Swiper
        className='swiper-wrapper'
        slidesPerView={4.75}
        initialSlide={3}
        loop={true}
        centeredSlides={true}
        freeMode={true}
        freeModeSticky={true}
        freeModeMomentumRatio={0}
        freeModeMomentumBounce={true}
        shortSwipes={false}
        longSwipes={false}
        longSwipesRatio={0}
        threshold={10}
        speed={100}
        slideToClickedSlide={true}
        onProgress={e => handleSwipe(e)}
        preventInteractionOnTransition={true}
        onTransitionEnd={e => {
          handleResetChipsScale(e)
          setCurrentChip(e.realIndex)
        }}
      >
        {CHIPS.map((chip, id) => (
          <SwiperSlide
            key={id}
            onClick={() =>
              !gameState && currentChip === id && handleCurrentChip(chip, id)
            }
          >
            <Chip anim={anim && currentChip === id}>
              <span>{chip}</span>
            </Chip>
          </SwiperSlide>
        ))}
      </Swiper>
    </SwiperContainer>
  )
}
